import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse } from '../../../models/cm-club-service.model';
import { SimpleResponse } from '../../../models/generic-response.model';
import { Membership, MemContactItem, MembershipListRequest, MembershipResponse, REF_MemAccountStatus, REF_MemCancellationReason, REF_MemCollectionsVendor, REF_MemCompany, REF_MemLocation, REF_MemNeverStartedReason, REF_MemPurchasedVesselBrand, REF_MemRegion, REF_MemResNetStatus, REF_MemSubscriptionType, REF_MemTerminationReason, REF_MemTradeReason, REFMem_GetAllResponse, MemContactListRequest, MemContactResponse, MemSubscription } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { UserService } from '../../../services/user.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
    selector: 'app-membership',
    templateUrl: './membership.component.html',
    styleUrls: ['./membership.component.css']
})
/** membership component*/
export class MembershipComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sortsub: MatSort;
    @ViewChild(MatPaginator) paginatorSub: MatPaginator;
    dataSource: MatTableDataSource<MemContactItem>;
    dataSourceSub: MatTableDataSource<MemSubscription>;
    displayedColumns: string[] = ['membershipAccountName', 'primaryCaptainFirstName', 'primaryCaptainLastName','membershipCompany', 'subscriptionType', 'membershipStartDate', 'dtCreated'];
    encryptedUser: string;
    memberships: Membership[];
    membershipData: Membership;
    membershipListRequest = {} as MembershipListRequest;
    user: BCMCLPUser;
    clpCompanyId: number;
    siteId: number;
    sites: number[];
    users: number[];
    class4Code: any;
    curTeam: TeamCodes = <TeamCodes>{};
    clubConfig: CMClub;
    membershipForm: FormGroup;

    //drop down
    ref_MemSubscriptionType:REF_MemSubscriptionType[] = [];
    ref_MemCompany:REF_MemCompany[] = [];
    ref_MemRegion:REF_MemRegion[] = [];
    ref_MemLocation:REF_MemLocation[] = [];
    ref_MemAccountStatus:REF_MemAccountStatus[] = [];
    ref_MemResNetStatus:REF_MemResNetStatus[] = [];
    ref_MemNeverStartedReason:REF_MemNeverStartedReason[] = [];
    ref_MemCancellationReason:REF_MemCancellationReason[] = [];
    ref_MemPurchasedVesselBrand:REF_MemPurchasedVesselBrand[] = [];
    ref_MemTerminationReason:REF_MemTerminationReason[] = [];
    ref_MemCollectionsVendor:REF_MemCollectionsVendor[] = [];
    ref_MemTradeReason: REF_MemTradeReason[] = [];

    membership = {} as Membership;
    incrementalId: number = 0;
    member: string = '';
    membershipID: number = 0;
    accountName: string = '';
    contactId: number = 0;

    columns = [
        { field: 'name', title: 'Name', width: '184' },
        { field: 'email', title: 'Email', width: '70' },
        { field: 'mobile', title: 'Mobile', width: '142' },
        { field: 'cmContractID', title: 'Contract', width: '142' },
        { field: 'memberStatus', title: 'Status', width: '142' },
        //{ field: 'subscriptionID', title: 'Subscription ID', width: '142' },
        { field: 'onboardedByCLPUser', title: 'Onboarded By', width: '142' },
        { field: 'dateOfLastReservation', title: 'Last Reservation', width: '142' },
    ];

    columnsSub = [
        { field: 'subscription', title: 'Subscription Name', width: '184' },
        { field: 'vSubscriptionID', title: 'Subscription Id', width: '142' },
        { field: 'totalAmount', title: 'Total Amount', width: '70' },
        { field: 'dtNextBill', title: 'Next Bill Date', width: '142' },

    ];
    sendMailInfo: any = { isShow: false, contactId: 0 };
    selectedContactId: number = 0;
    memContactListDisplayColumns: string[];
    contactList: MemContactItem[];
    memSubDisplayColumns: string[];
    memSubscription: MemSubscription[];

    /** membership ctor */
    constructor(private localService: LocalService,
        private userService: UserService,
        private fb: FormBuilder,
        private _utilityService: UtilityService,
        private clubService: CMClubService,
        private _membershipService: MembershipService,
        private _notifyService: NotificationService,
        private _globalService: GlobalService,
        private _router: Router,
        private route: ActivatedRoute,
        private datePipe: DatePipe    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-membership");
    }

    ngAfterViewInit() {
        this.sites = [];
        this.encryptedUser = localStorage.getItem("token");
        this.siteId = this.route.snapshot.queryParams.siteId;
        this.sites.push(1);
        this.class4Code = this.route.snapshot.queryParams.c4Code;
        this.incrementalId = +this.route.snapshot.paramMap.get('membershipIID');
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.users = [];
                    this.users.push(this.user.cLPUserID);
                    this.loadData();
                    this.loadDropDownData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    ngOnInit() {
        this.membershipForm = this.prepareMembershipForm()
    }

    prepareMembershipForm() {
        return this.fb.group({
            firstName: [{ value: '', disabled: true }],
            lastName: [{ value: '', disabled: true }],
            primaryName: [{ value: '', disabled: true }],
            subscriptionType: ['0'],
            memStartDate: [''],
            membershipCompany: ['0'],
            siteId: ['0'],
            accountStatus: ['0'],
            salesCloseDate: [''],
            currAprDate: [''],
            daysAR: [{ value: '0', disabled: true }],
            prePaidMonthlyAmount: ['0'],
            payThroughDate: [''],
            memberForMonths: [{ value: '0', disabled: true }],
            resNetStatus: ['0'],
            totAccountReservations: [{ value: '0', disabled: true }],
            last12MonthsReservations: [{ value: '0', disabled: true }],
            secDepositAmountHeld: ['0'],
            secDepositeDate: [''],
            refundRequestDate: [''],
            neverStartedReason: ['0'],
            neverStartedNotes: [''],
            neverStartDate: [''],
            cancellationReason: ['0'],
            canRequestDate: [''],
            canDateLastDayOfMembership: [''],
            memPriorToCancellation: [0],
            cancellationNotes: [''],
            canDaysRemaining: ['0'],
            canAmountRemaining: ['0'],
            purchasedVesselBrand: ['0'],
            purchasedFromBoat: ['0'],
            terminationDate: [''],
            terminationReason: ['0'],
            cancelledAmountRemaining: ['0'],
            sentCollectionsDate: [''],
            collectionsVendor: ['0'],
            collectionsReceivedDate: [''],
            collectionsReceivedAmount: ['0'],
            tradeReason: ['0'],
            //contactEmail: ['']
        })
    }

    private async authenticateR() {

        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID
                    
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getDate(value) {
        if (value == '0001-01-01T00:00:00') {
            return '';
        }
        else
            return value;
    }

    async loadData() {
        await this.CMClub_Get();
        await this.getMembership();
        await this.getmemContact_CMMember_List();
    }

    formatDate(dateString) {
        if (dateString != '') {
            const date = new Date(dateString);
            //const formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            return formattedDate;
        }
        else return '';
    }

    async loadDropDownData() {
        if (this.localService.refMem_GetAllResponse?.ref_MemSubscriptionType_List === null ||
            this.localService.refMem_GetAllResponse?.ref_MemSubscriptionType_List === undefined) {
            await this.localService.GetAll_REFs(this.encryptedUser, this.user?.cLPCompanyID);
        }

        if (!this.ref_MemSubscriptionType)
            this.ref_MemSubscriptionType = [];
        this.ref_MemSubscriptionType = this.localService.refMem_GetAllResponse?.ref_MemSubscriptionType_List;
        if (!this.ref_MemCompany)
            this.ref_MemCompany = [];
        this.ref_MemCompany = this.localService.refMem_GetAllResponse?.ref_MemCompany_List;
        if (!this.ref_MemRegion)
            this.ref_MemRegion = [];
        this.ref_MemRegion = this.localService.refMem_GetAllResponse?.ref_MemRegion_List;
        if (!this.ref_MemLocation)
            this.ref_MemLocation = [];
        this.ref_MemLocation = this.localService.refMem_GetAllResponse?.ref_MemLocation_List;
        if (!this.ref_MemAccountStatus)
            this.ref_MemAccountStatus = [];
        this.ref_MemAccountStatus = this.localService.refMem_GetAllResponse?.ref_MemAccountStatus_List;
        if (!this.ref_MemResNetStatus)
            this.ref_MemResNetStatus = [];
        this.ref_MemResNetStatus = this.localService.refMem_GetAllResponse?.ref_MemResNetStatus_List;
        if (!this.ref_MemNeverStartedReason)
            this.ref_MemNeverStartedReason = [];
        this.ref_MemNeverStartedReason = this.localService.refMem_GetAllResponse?.ref_MemNeverStartedReason_List;
        if (!this.ref_MemCancellationReason)
            this.ref_MemCancellationReason = [];
        this.ref_MemCancellationReason = this.localService.refMem_GetAllResponse?.ref_MemCancellationReason_List;
        if (!this.ref_MemPurchasedVesselBrand)
            this.ref_MemPurchasedVesselBrand = [];
        this.ref_MemPurchasedVesselBrand = this.localService.refMem_GetAllResponse?.ref_MemPurchasedVesselBrand_List;
        if (!this.ref_MemTerminationReason)
            this.ref_MemTerminationReason = [];
        this.ref_MemTerminationReason = this.localService.refMem_GetAllResponse?.ref_MemTerminationReason_List;
        if (!this.ref_MemCollectionsVendor)
            this.ref_MemCollectionsVendor = [];
        this.ref_MemCollectionsVendor = this.localService.refMem_GetAllResponse?.ref_MemCollectionsVendor_List;
        if (!this.ref_MemTradeReason)
            this.ref_MemTradeReason = [];
        this.ref_MemTradeReason = this.localService.refMem_GetAllResponse?.ref_MemTradeReason_List;
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {            
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                   
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async getMembership() {
        await this._membershipService.Membership_Get(this.encryptedUser, this.incrementalId).
            then(async (result: Membership) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.membershipData = response;
                    console.log('this.membershipData', this.membershipData);
                    if (this.membershipData.incrementalID > 0) {
                        this.patchMembership();
                        this.memSubscription_Get(this.membershipData?.incrementalID);
                    }
                }                
            })
            .catch((err: HttpErrorResponse) => {              
                this._globalService.error("membership.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveUpdateMemberShip() {
        this.preparMembership();
        await this._membershipService.membership_Update(this.encryptedUser, this.membership).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this._router.navigate(['/mem-membership'], { queryParams: { insuranceDeductibleID: this.incrementalId } });
                        Swal.fire({ icon: "success", title: "", html: 'Member Successfully Updated!' });
                        return;
                    } else {
                        Swal.fire({ icon: "error", title: "", html: 'Something went worng, Please try after Sometime!' });
                        return;
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-ship.saveUpdateMemberShip", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    preparMembership() {
        this.membership.clpCompanyID = this.user.cLPCompanyID;
        this.membership.clpUserID = this.user.cLPUserID;
        //this.membership.clubID = this.clubConfig?.clubId ? this.clubConfig?.clubId:0;
        this.membership.clubID = this.membershipData.clubID;
        this.membership.incrementalID = this.incrementalId;
        this.membership.siteID = this.siteId;
        this.membership.contractID = this.membershipData.contractID;
        this.membership.contactID = this.membershipData.contactID;
        this.membership.dtCreated = this.membershipData.dtCreated;
        this.membership.resNetID = this.membershipData.resNetID;
        this.membership.stripeCustomerID = this.membershipData.stripeCustomerID;
        this.membership.primaryCaptainFirstName = this.membershipForm.controls.firstName.value;
        this.membership.primaryCaptainLastName = this.membershipForm.controls.lastName.value;
        this.membership.subscriptionType = this.membershipForm.controls.subscriptionType.value;
        this.membership.membershipStartDate = this.datePipe.transform(this.membershipForm.controls.memStartDate.value, 'MM/dd/yyyy');
        this.membership.membershipCompany = this.membershipForm.controls.membershipCompany.value;

        this.membership.siteID = this.membershipForm.controls.siteId.value;
        this.membership.accountStatus = this.membershipForm.controls.accountStatus.value;
        this.membership.salesClosedDate = this.datePipe.transform(this.membershipForm.controls.salesCloseDate.value, 'MM/dd/yyyy');
        this.membership.currentARDate = this.datePipe.transform(this.membershipForm.controls.currAprDate.value, 'MM/dd/yyyy');

        this.membership.daysAR = this.membershipForm.controls.daysAR.value;
        this.membership.prePaidMonthlyAmount = this.membershipForm.controls.prePaidMonthlyAmount.value;
        this.membership.prePaidMonthlyPaymentThroughDate = this.datePipe.transform(this.membershipForm.controls.payThroughDate.value, 'MM/dd/yyyy');
        this.membership.memberForMonths = this.membershipForm.controls.memberForMonths.value;
        this.membership.resNetStatus = this.membershipForm.controls.resNetStatus.value;

        this.membership.totalAccountReservations = this.membershipForm.controls.totAccountReservations.value;
        this.membership.last12MonthsReservations = this.membershipForm.controls.last12MonthsReservations.value;
        this.membership.securityDepositAmountHeld = this.membershipForm.controls.secDepositAmountHeld.value;
        this.membership.securityDepositedDate = this.datePipe.transform(this.membershipForm.controls.secDepositeDate.value, 'MM/dd/yyyy');
        this.membership.securityDepositRefundRequestDate = this.datePipe.transform(this.membershipForm.controls.refundRequestDate.value, 'MM/dd/yyyy');
        this.membership.neverStartedReason = this.membershipForm.controls.neverStartedReason.value;

        this.membership.neverStartedNotes = this.membershipForm.controls.neverStartedNotes.value;
        this.membership.neverStartedDate = this.datePipe.transform(this.membershipForm.controls.neverStartDate.value, 'MM/dd/yyyy');
        this.membership.cancellationReason = this.membershipForm.controls.cancellationReason.value;
        this.membership.cancellationRequestDate = this.datePipe.transform(this.membershipForm.controls.canRequestDate.value, 'MM/dd/yyyy');
        this.membership.cancellationDateLastDayOfMembership = this.datePipe.transform(this.membershipForm.controls.canDateLastDayOfMembership.value, 'MM/dd/yyyy');

        //this.membership.daysMemberPriorToCancellation = this.membershipForm.controls.memPriorToCancellation.value;
        this.membership.cancellationNotes = this.membershipForm.controls.cancellationNotes.value;
        this.membership.cancelledDaysRemainingInContract = this.membershipForm.controls.canDaysRemaining.value;
        this.membership.cancelledAmountRemaining = this.membershipForm.controls.canAmountRemaining.value;
        this.membership.purchasedVesselBrand = this.membershipForm.controls.purchasedVesselBrand.value;

        this.membership.purchasedFromBoatSimple = this.membershipForm.controls.purchasedFromBoat.value;
        this.membership.terminationDate = this.membershipForm.controls.terminationDate.value;
        this.membership.terminationReason = this.membershipForm.controls.terminationReason.value;
        this.membership.sentToCollectionsDate = this.datePipe.transform(this.membershipForm.controls.sentCollectionsDate.value, 'MM/dd/yyyy');

        this.membership.collectionsVendor = this.membershipForm.controls.collectionsVendor.value;
        this.membership.collectionsReceivedDate = this.datePipe.transform(this.membershipForm.controls.collectionsReceivedDate.value, 'MM/dd/yyyy');
        this.membership.collectionsReceivedAmount = this.membershipForm.controls.collectionsReceivedAmount.value;
        this.membership.tradeReason = this.membershipForm.controls.tradeReason.value;
        //this.membership.contactEmail = this.membershipForm.controls.contactEmail.value;
    }

    patchMembership() {
        this.membershipForm.patchValue({
            firstName: this.membershipData?.primaryCaptainFirstName,
            lastName: this.membershipData?.primaryCaptainLastName,
            primaryName: `${this.membershipData?.primaryCaptainFirstName} ${this.membershipData?.primaryCaptainLastName}`,
            subscriptionType: this.membershipData?.subscriptionType,
            memStartDate: this.membershipData?.membershipStartDate,
            membershipCompany: this.membershipData?.membershipCompany,
            siteId: this.membershipData?.siteID,
            accountStatus: this.membershipData?.accountStatus,
            salesCloseDate: this.membershipData?.salesClosedDate,
            currAprDate: this.membershipData?.currentARDate,
            daysAR: this.membershipData?.daysAR,
            prePaidMonthlyAmount: this.membershipData?.prePaidMonthlyAmount,
            payThroughDate: this.membershipData?.prePaidMonthlyPaymentThroughDate,
            memberForMonths: this.membershipData?.memberForMonths,
            resNetStatus: this.membershipData?.resNetStatus,
            totAccountReservations: this.membershipData?.totalAccountReservations,
            last12MonthsReservations: this.membershipData?.last12MonthsReservations,
            secDepositAmountHeld: this.membershipData?.securityDepositAmountHeld,
            secDepositeDate: this.membershipData?.securityDepositedDate,
            refundRequestDate: this.membershipData?.securityDepositRefundRequestDate,
            neverStartedReason: this.membershipData?.neverStartedReason,
            neverStartedNotes: this.membershipData?.neverStartedNotes,
            neverStartDate: this.membershipData?.neverStartedDate,
            cancellationReason: this.membershipData?.cancellationReason,
            canRequestDate: this.membershipData?.cancellationRequestDate,
            canDateLastDayOfMembership: this.membershipData?.cancellationDateLastDayOfMembership,
            memPriorToCancellation: this.membershipData?.daysMemberPriorToCancellation,
            cancellationNotes: this.membershipData?.cancellationNotes,
            canDaysRemaining: this.membershipData?.cancelledDaysRemainingInContract,
            canAmountRemaining: this.membershipData?.cancelledAmountRemaining,
            purchasedVesselBrand: this.membershipData?.purchasedVesselBrand,
            purchasedFromBoat: this.membershipData?.purchasedFromBoatSimple,
            terminationDate: this.membershipData?.terminationDate,
            terminationReason: this.membershipData?.terminationReason,
            sentCollectionsDate: this.membershipData?.sentToCollectionsDate,
            collectionsVendor: this.membershipData?.collectionsVendor,
            collectionsReceivedDate: this.membershipData?.collectionsReceivedDate,
            collectionsReceivedAmount: this.membershipData?.collectionsReceivedAmount,
            tradeReason: this.membershipData?.tradeReason,
            //contactEmail: ['']

        });

        this.member = `${this.membershipData?.primaryCaptainFirstName} ${this.membershipData?.primaryCaptainLastName}`;
        this.accountName = this.membershipData?.membershipAccountName;
        this.membershipID = this.membershipData?.membershipID;
        this.contactId = this.membershipData?.contactID;
        this.membership.clpCompanyID = this.user.cLPCompanyID;
        this.membership.clpUserID = this.user.cLPUserID;
        this.membership.clubID = this.clubConfig?.clubId;
        this.membership.incrementalID = this.incrementalId;
        this.membership.membershipID = this.membershipData?.membershipID;
        this.membership.siteID = this.siteId;
        this.membership.stripeCustomerID = '';
        this.membership.primaryCaptainFirstName = this.membershipForm.controls.firstName.value;
        this.membership.primaryCaptainLastName = this.membershipForm.controls.lastName.value;
        this.membership.subscriptionType = this.membershipForm.controls.subscriptionType.value;
        this.membership.membershipStartDate = this.datePipe.transform(this.membershipForm.controls.memStartDate.value, 'MM/dd/yyyy');
        this.membership.membershipCompany = this.membershipForm.controls.membershipCompany.value;

        this.membership.accountStatus = this.membershipForm.controls.accountStatus.value;
        this.membership.salesClosedDate = this.datePipe.transform(this.membershipForm.controls.salesCloseDate.value, 'MM/dd/yyyy');
        this.membership.currentARDate = this.membershipForm.controls.currAprDate.value;

        this.membership.daysAR = this.membershipForm.controls.daysAR.value;
        this.membership.prePaidMonthlyAmount = this.membershipForm.controls.prePaidMonthlyAmount.value;
        this.membership.prePaidMonthlyPaymentThroughDate = this.datePipe.transform(this.membershipForm.controls.payThroughDate.value, 'MM/dd/yyyy');
        this.membership.memberForMonths = this.membershipForm.controls.memberForMonths.value;
        this.membership.resNetStatus = this.membershipForm.controls.resNetStatus.value;

        this.membership.totalAccountReservations = this.membershipForm.controls.totAccountReservations.value;
        this.membership.last12MonthsReservations = this.membershipForm.controls.last12MonthsReservations.value;
        this.membership.securityDepositAmountHeld = this.membershipForm.controls.secDepositAmountHeld.value;
        this.membership.securityDepositedDate = this.datePipe.transform(this.membershipForm.controls.secDepositeDate.value, 'MM/dd/yyyy');
        this.membership.securityDepositRefundRequestDate = this.datePipe.transform(this.membershipForm.controls.refundRequestDate.value, 'MM/dd/yyyy');
        this.membership.neverStartedReason = this.membershipForm.controls.neverStartedReason.value;

        this.membership.neverStartedNotes = this.membershipForm.controls.neverStartedNotes.value;
        this.membership.neverStartedDate = this.datePipe.transform(this.membershipForm.controls.neverStartDate.value, 'MM/dd/yyyy');
        this.membership.cancellationReason = this.membershipForm.controls.cancellationReason.value;
        this.membership.cancellationRequestDate = this.datePipe.transform(this.membershipForm.controls.canRequestDate.value, 'MM/dd/yyyy');
        this.membership.cancellationDateLastDayOfMembership = this.datePipe.transform(this.membershipForm.controls.canDateLastDayOfMembership.value, 'MM/dd/yyyy');

        this.membership.daysMemberPriorToCancellation = this.membershipForm.controls.memPriorToCancellation.value;
        this.membership.cancellationNotes = this.membershipForm.controls.cancellationNotes.value;
        this.membership.cancelledDaysRemainingInContract = this.membershipForm.controls.canDaysRemaining.value;
        this.membership.cancelledAmountRemaining = this.membershipForm.controls.canAmountRemaining.value;
        this.membership.purchasedVesselBrand = this.membershipForm.controls.purchasedVesselBrand.value;

        this.membership.purchasedFromBoatSimple = this.membershipForm.controls.purchasedFromBoat.value;
        this.membership.terminationDate = this.membershipForm.controls.terminationDate.value;
        this.membership.terminationReason = this.membershipForm.controls.terminationReason.value;
        this.membership.sentToCollectionsDate = this.datePipe.transform(this.membershipForm.controls.sentCollectionsDate.value, 'MM/dd/yyyy');

        this.membership.collectionsVendor = this.membershipForm.controls.collectionsVendor.value;
        this.membership.collectionsReceivedDate = this.datePipe.transform(this.membershipForm.controls.collectionsReceivedDate.value, 'MM/dd/yyyy');
        this.membership.collectionsReceivedAmount = this.membershipForm.controls.collectionsReceivedAmount.value;
        this.membership.tradeReason = this.membershipForm.controls.tradeReason.value;
        //this.membership.contactEmail = this.membershipForm.controls.contactEmail.value;
    }



    async memSubscription_Get(memberShipId: number) {
        await this._membershipService.memSubscription_GetByMemId(this.encryptedUser, memberShipId)
            .then(async (result: MemSubscription[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memSubscription = response;
                    this.setSubGrid(this.memSubscription);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }



    async getmemContact_CMMember_List() {
        let memContactRequest: MemContactListRequest = <MemContactListRequest>{};
        memContactRequest.clubId = this.clubConfig?.clubId;
        memContactRequest.membershipIID = this.incrementalId;
        memContactRequest.clpCompanyId = this.user?.cLPCompanyID;
        await this._membershipService.memContact_cmMember_GetList(this.encryptedUser, memContactRequest, this.user?.cLPUserID)
            .then(async (result: MemContactResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contactList = response.contacts;
                    this.setGrid(this.contactList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("membership.getCMMember_Contact_List", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    gotoLink(event, columnName, dataItem) {
        switch (columnName) {
            case "email":
                {
                    $('#sendEmail').modal('show');
                    this.sendMailInfo.isShow = true;
                    this.sendMailInfo.contactId = dataItem?.contactID;
                }
                break;
            case "memContact":
                {
                    const _route = `/mem-contact/${dataItem?.contactID}`;
                    window.open(_route, '_blank');
                }
                break;
            case "mobile":
                {
                    this.selectedContactId = dataItem?.contactID;
                    $('#sendTextModal').modal('show');
                }
                break;
            case "cmContract":
                {
                    let url = "cm-contract/" + dataItem?.contactID + '?r=' + this.encryptedUser
                    window.open(url, '_blank')
                }
                break;
            case "memSubscription":
                {
                    const url = `/mem-subscription?subscriptionID=${dataItem?.membershipIID}`;
                    window.open(url, '_blank');
                }
                break;
            default:
        }
    }

    setGrid(list) {
        this.memContactListDisplayColumns = this.columns.map(c => c.field);
        this.dataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.dataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        }, 500)
    }

    setSubGrid(list) {
        this.memSubDisplayColumns = this.columnsSub.map(c => c.field);
        this.dataSourceSub = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.dataSourceSub.paginator = this.paginatorSub;
            if (this.paginatorSub) {
                this.paginatorSub.pageSize = 50;
            }
            if (this.sortsub) {
                this.dataSourceSub.sort = this.sortsub;
            }
        }, 500)
    }


    selectRow(row: any) {
        console.log(row)
        const _route = `/mem-contact/${row?.contactID}`;
        window.open(_route, '_blank');
        //this._router.navigate(['/mem-contact/', row?.contactID]
        //    );
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    hideTextMsgModal(sms?: boolean) {
        this.selectedContactId = 0;
        $('#sendTextModal').modal('hide');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
